/*
*###############################################################################
*Module Name                   : VoucherSell.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 6th 2022, 9:51:24 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState, useEffect } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, Col, Container, Row, CardBody } from "reactstrap"

//**Importing required componant files   */
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import VoucherTransferInContent from "./VoucherSellContent"
import DPInfoBox from "framework/layout/DPInfoBox"
import { Text, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import { SaveUpdateVouchers, getVoucherSale } from "./VoucherSellController"
//*Detail content */
import VoucherTransferInDetails from "./VoucherSellDetails"
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"
import VoucherSellSummarySection from "./VoucherSellSummarySection"
import VoucherPayments from "./VoucherPayments"
import DPPrintOption from "framework/widgets/DPPrintOptions"
//**End Importing required componant files */


const detailObj = [{
  code: "",
  desc: "",
  VoucherFrom: "",
  VoucherTo: "",
  DiscPer: 0,
  DiscAmt: 0,
  Amount: 0,
  Selling: 0,
  Cost: 0,
  id: 1,
  disable: false,
  count: 0,
  disableFrom: false,
  disableTo: true,
}]


const paymentObj = [
  {
    id: 1,
    Paycode: "",
    PayCodeDisable: false,
    Paydesc: "",
    PayDetcode: "",
    PayDetcodeDesable: true,
    PayDetName: "",
    PayAmount: 0,
    PayAmountDisable: true,
    AccountCode: "",
    AccountCodeDisable: true,
    ExpDate: "",
    ExpDateDisable: true,
    PayDetFormat: ""
  }
]


const VoucherSell = props => {
  //*** User input related states */
  let today = new Date()
  let date = today.toISOString().split("T")[0]

  let history = useHistory();
  const {
    isHeadOffice, getMenuDetails, setupLocation, masterAuditLog, addtoFavourite
  } = useContext(Context);


  const [strVoucherCode, SetVoucherCode] = useState("0000000000000") // Set Code
  const [blVoucherCodeEnable, SetVoucherCodeEnable] = useState(false)
  const [disable, setDisable] = useState(false)
  const [strVoucherDate, SetVoucherDate] = useState(date) //Set DATE
  const [blVoucherDateEnable, SetVoucherDateEnable] = useState(false)
  const [strFromLocation, SetFromLocation] = useState("")
  const [blFromLocationEnable, SetFromLocationEnable] = useState(false)
  const [strToLocation, SetToLocation] = useState("")

  const [strRemarks1, SetRemarks1] = useState("")
  const [blRemarks1Enable, SetRemarks1Enable] = useState(false)
  const [strRemarks2, SetRemarks2] = useState("")
  const [blRemarks2Enable, SetRemarks2Enable] = useState(false)
  const [strRefNo, SetRefNo] = useState("")
  const [blRefNoEnable, SetRefNoEnable] = useState(false)
  const [blmainSearchEnable, SetmainSearchEnable] = useState(false)
  const [customerCode, setCustomerCode] = useState("")
  const [customerName, setCustomerName] = useState("")
  const [salesAssist, setSalesAssist] = useState("")
  const [salesAssistName, setSalesAssistName] = useState("")
  const [priceMode, setPriceMode] = useState("")
  const [disableSalesAssist, setDisableSalesAssist] = useState(false)
  const [disableCustomer, setDisableCustomer] = useState(false)

  const [grossAmount, setGrossAmount] = useState(0)
  const [discountPercentage, setDiscountPercentage] = useState(0)
  const [discountAmount, setDiscountAmount] = useState(0)
  const [additions, setAdditions] = useState(0)
  const [deductions, setDeductions] = useState(0)
  const [taxInclusive, setTaxInclusive] = useState(0)
  const [taxExclusive, setTaxExclusive] = useState(0)
  const [netAmount, setNetAmount] = useState(0)


  const [addNew, SetAddNew] = useState(true)
  const [strRefCode, SetRefCode] = useState("")
  const [blRefCodeEnable, SetRefCodeEnable] = useState(false)

  const [locationDescFrom, SetLocationDescFrom] = useState("")
  const [locationDescTo, SetLocationDescTo] = useState("")

  const [locationFromDisable, SetLocationFromDisable] = useState(false)
  const [locationToDisable, SetLocationToDisable] = useState(false)

  //*** End User input related states */

  //*** User Activity related states*/

  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [AlertShow, setAlertShow] = useState(false)
  const [ShowTaxTable, setShowTaxTable] = useState(false)
  const [blDiasableGrid, SetblDiasableGrid] = useState(false)

  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_xlargeMain, setmodal_xlargeMain] = useState(false)
  const [model_xlarge_locTo, setmodel_xlarge_locTo] = useState(false)
  const [model_xlarge_locFrom, setmodel_xlarge_locFrom] = useState(false)
  const [disabledDesc, setDisabledDesc] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [SupplierOpen, SetSupplieropen] = useState(false)
  const [menuCode, SetMenuCode] = useState("")

  //*** End User activity related staes */

  //*** useState to save table data */
  const [DataTables, SetDatatable] = useState([])
  const [DataTablesMain, SetDatatableMain] = useState([])

  const [strReason, setReason] = useState("Created")
  //*** End of useStates */

  const [disabled, setDisabled] = useState(false)
  const [detailRows, setDetailRows] = useState(detailObj)
  const [rowsTax, setrowsTax] = useState([])

  const [paymentList, setPaymentList] = useState(paymentObj)
  const [paidAmount, setPaidAmount] = useState(0)

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  const [printEnable, setPrintEnable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  //*****Menu Rights End */
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  const [helpUrl, setHelpUrl] = useState("")
  //**Get File Details */

  var time = process.env.REACT_APP_ALERTTIMEOUT

  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)



    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setPermissionReasonShow(result.data.strMenuReasonShow)
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setHelpUrl(result.data.strHelpUrl)
      }).catch(error =>
        console.log('error', error)
      );


    getLocation(LocationCode, 1)

  }, [])


  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])



  useEffect(() => {
    updateCalculatedRows();
  }, [discountPercentage])



  // Calculate function based on row properties
  const calculateRow = (row) => {
    if (row.Selling === null || row.count === null || row.DiscPer === null || row.DiscAmt === null) {
      row.Amount = 0; // Or another appropriate default value
    } else {
      // Calculate initial amount
      const initialAmount = row.Selling * row.count;

      // Calculate final amount after discount percentage is subtracted
      const amountAfterDiscountPer = initialAmount - ((row.DiscPer || 0) / 100) * initialAmount;

      // Calculate amount after discount amount is subtracted
      row.Amount = amountAfterDiscountPer - (row.DiscAmt || 0);
    }

    return row;
  };

  // Update the detailRows array with calculated values
  const updateCalculatedRows = async (updatedrows = []) => {

    let calculatedRows = updatedrows.length > 0 ? updatedrows : detailRows;

    const updatedRows = calculatedRows.map((row) => calculateRow(row));
    setDetailRows(updatedRows);


    // Calculate total amount and total discount
    const { totalAmount, totalDiscount } = updatedRows.reduce(
      (totals, row) => {
        totals.totalAmount += parseFloat(row.Amount);
        totals.totalDiscount += (parseFloat(row.DiscAmt || 0) + ((parseFloat(parseFloat(row.DiscPer).toFixed(2) || 0) / 100) * (parseFloat(row.Selling) * parseFloat(row.count))));
        return totals;
      },
      { totalAmount: 0, totalDiscount: 0 }
    );

    const { totalDiscountExcluded } = updatedRows.reduce((totals, row) => {

      if (row.DiscPer === 0 && row.DiscAmt === 0) {
        totals.totalDiscountExcluded += (parseFloat(discountPercentage || 0) / 100) * (parseFloat(row.Selling) * parseFloat(row.count));
      }

      return totals;
    },
      { totalDiscountExcluded: 0 }
    );

    setDiscountAmount(totalDiscount + totalDiscountExcluded)
    setGrossAmount(totalAmount)
    setNetAmount(totalAmount - totalDiscountExcluded)

  };


  async function CalculatePaidAmount(editedList = []) {

    //calculate paid amount
    var paidAmount = 0


    if (editedList.length > 0) {
      editedList.map((item) => {

        if (item.Paycode != "") {
          paidAmount = paidAmount + parseFloat(DecimalValidation(item.PayAmount))
        }

      })
    } else {
      paymentList.map((item) => {

        if (item.Paycode != "") {
          paidAmount = paidAmount + parseFloat(DecimalValidation(item.PayAmount))
        }

      })
    }

    setPaidAmount(paidAmount)

  }



  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tog_xlargeMain() {
    setmodal_xlargeMain(!modal_xlargeMain)
    removeBodyCss()
  }

  function tox_xlarge_locTo() {
    setmodel_xlarge_locTo(!model_xlarge_locTo)
    removeBodyCss()
  }

  function tox_xlarge_locFrom() {
    setmodel_xlarge_locFrom(!model_xlarge_locFrom)
    removeBodyCss()
  }



  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  //save button function
  const handlesave = async () => {

    if (strFromLocation == "") {
      displayAlertMessage('danger', "Please Select a From Location")
      return
    }

    if (priceMode == "") {
      displayAlertMessage('danger', "Please Select a Price Mode")
      return
    }


    let voucherDetails = []
    let voucherPayments = []



    detailRows.map((item, index) => {

      if (item.code != "") {
        voucherDetails.push(VoucherDetailBuilder(item, index))
      }

    })

    paymentList.map((item, index) => {

      if (item.Paycode != "" && item.PayAmount > 0) {
        voucherPayments.push(VoucherPaymentBuilder(item, index))
      }

    })



    if (voucherDetails.length == 0) {
      displayAlertMessage('danger', "Please Add Items")
      return
    }


    if (voucherPayments.length == 0) {
      displayAlertMessage('danger', "Please Add Payments")
      return
    }


    if (paidAmount == 0) {
      displayAlertMessage('danger', "Please Add Payments")
      return
    }

    if (parseFloat(paidAmount) != parseFloat(netAmount)) {
      displayAlertMessage('danger', "Paid Amount and Net Amount Not Equal")
      return
    }



    var datey = new Date()
    var hours = datey.getHours() < 10 ? "0" + datey.getHours() : datey.getHours()
    var minitues = datey.getMinutes() < 10 ? "0" + datey.getMinutes() : datey.getMinutes()
    var seconds = datey.getSeconds() < 10 ? "0" + datey.getSeconds() : datey.getSeconds()
    const transTime = strVoucherDate + "T" + hours + ":" + minitues + ":" + seconds


    var voucher = {

      strHED_TYPE: "BVS",
      strHED_REFTYPE: "",
      strHED_RUNNO: strVoucherCode == "0" ? "NAN" : strVoucherCode,
      dtHED_TXNDATE: strVoucherDate,
      dtHED_PROCDATE: strVoucherDate,
      dtHED_TXNTIME: transTime,
      strHED_SETUPLOC: setupLocation,
      strHED_LOCFROM: strFromLocation,
      strHED_LOCTO: "",
      strHED_LOCDEL: "",
      strHED_COMCODE: LogCompanyCode,
      strHED_PRICEMODE: priceMode,
      strHED_CUSCODE: customerCode,
      strHED_LOC: LocationCode,
      strHED_SUPCODE: "",
      strHED_REFNO: "",
      strHED_REF1: "",
      strHED_REF2: "",
      decHED_SELLAMT: parseFloat(netAmount),
      decHED_GROSSAMT: parseFloat(grossAmount),
      decHED_DISCPER: parseFloat(discountPercentage),
      decHED_ITAXAMT: parseFloat(0),
      decHED_ETAXAMT: parseFloat(0),
      decHED_ADDAMT: parseFloat(0),
      decHED_DEDAMT: parseFloat(0),
      decHED_NETAMT: parseFloat(netAmount),
      decHED_RECCOUNT: voucherDetails.length,
      decHED_REFCOUNT: 0,
      intHED_PROCESSED: 0,
      intHED_LOCKED: 0,
      intHED_CANCELLED: 0,
      dtHED_CANDATE: "1900-01-01",
      strHED_CANUSER: "",
      decHED_PRINTCOUNT: 0,
      decHED_REFDOCVAL: 0,
      intHED_FULLYUSED: 0,
      intHED_EXPORT: 0,
      strHED_EXPBATCH: "",
      HED_BEFOREDATE: "1900-01-01",
      HED_AFTERDATE: "1900-01-01",
      strHED_EXTREFDOC: "",
      objTXN_DETSAVE: voucherDetails,
      objTXN_DETTAXSAVE: [],
      objPayment: voucherPayments,
      strSM_NAME: "",
      strCM_FULLNAME: customerName,
      strCR_BY: LogUserType,
      strMenuCode: menuCode,
      strLoggedCompany: LogCompanyCode,
      strLoggedLocation: LocationCode,
      strReason: "",
      dtHED_VALIDFROMDATE: "1900-01-01",
      dtHED_VALIDTODATE: "1900-01-01",
    }


    SetLoadingAlert(true)
    if (addNew == true) {
      SetLoadingAlerttitle("Saving...")
    } else {
      SetLoadingAlerttitle("Updating...")
    }

    const resultData = await SaveUpdateVouchers(voucher)

    SetLoadingAlert(false)

    if (resultData.success) {
      displayAlertMessage('success', `Save Success!.Document No is ${resultData.message}`)
      ClearItem()

    } else {
      displayAlertMessage('danger', resultData.message)

    }

  }

  //Voucher Po table Array
  const VoucherDetailBuilder = (row, index) => {
    return {
      strDET_TYPE: "BVS",
      strDET_RUNNO: "",
      strDET_COMCODE: LogCompanyCode,
      strDET_LOCCODE: strFromLocation,
      strDET_SACODE: salesAssist,
      dcDET_LINENO: index + 1,
      strDET_PROCODE: row.code,
      strDET_STOCKCODE: "",
      strDET_PRODESC: "",
      strDET_UNIT: "",
      dcDET_CS: 0,
      dtDET_EXPDATE: "1900-01-01",
      strDET_EXPBATCH: "",
      dcDET_SYSQTY: parseFloat(row.count),
      dcDET_CASEQTY: 0,
      dcDET_UNITQTY: 0,
      dcDET_FCASEQTY: 0,
      dcDET_FUNITQTY: 0,
      dcDET_BALQTY: 0,
      dcDET_VARQTY: 0,
      dcDET_OSPRICE: 0,
      dcDET_OCPRICE: 0,
      dcDET_OAPRICE: 0,
      dcDET_SPRICE: 0,
      dcDET_CPRICE: 0,
      dcDET_ACOST: 0,
      dcDET_APRICE: 0,
      dcDET_DISCPER: parseFloat(row.DiscPer),
      dcDET_DISCAMT: parseFloat(row.DiscAmt),
      dcDET_AMOUNT: parseFloat(row.Amount),
      strDET_REMCODE: "",
      strDET_VOUCHERFROM: row.VoucherFrom,
      strDET_VOUCHERTO: row.VoucherTo,
    }
  }


  const VoucherPaymentBuilder = (row) => {
    let date = new Date().toISOString();
    return {
      dcPaidAmount: parseFloat(row.PayAmount),
      dtDateTime: date.toString().slice(0, 10),
      dcAmount: parseFloat(netAmount),
      intCancelled: 0,
      strPDCode: row.PayDetcode,
      strPHCode: row.Paycode,
      strRefNo: row.AccountCode,
      dtPayTypeDate: row.ExpDate == "" ? "1900-01-01" : row.ExpDate,
      dcRate: parseFloat(1),
    }
  }

  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    SetRefCode(row.INVHED_INVNO)
    GetVoucherSaleDetails(row.INVHED_INVNO)
    setmodal_xlarge(!modal_xlarge)
  }

  const GetSelectRowMain = (e, row, isSelect, rowIndex) => {
    SetVoucherCode(row.INVHED_INVNO)
    GetVoucherSaleDetails(row.INVHED_INVNO)
    setmodal_xlargeMain(!modal_xlargeMain)
  }

  const GetSelectRowLocFrom = (e, row, isSelect, rowIndex) => {
    SetFromLocation(row.LOC_CODE)
    getLocation(row.LOC_CODE, 1)
    setmodel_xlarge_locFrom(!model_xlarge_locFrom)
  }

  const GetSelectRowLocTo = (e, row, isSelect, rowIndex) => {
    SetToLocation(row.LOC_CODE)
    getLocation(row.LOC_CODE, 2)
    setmodel_xlarge_locTo(!model_xlarge_locTo)
  }


  //edit button function
  const handleEdit = e => {
    setDisabledDesc(false)
    setDisabledCode(true)
    setSaveEnable(true)
  }

  //new button function
  const handleNew = e => {
    ClearItem()
    setAlertMsg(false)
    setSaveEnable(true)
  }

  //clear fields function
  const ClearItem = () => {
    let today = new Date()
    let date = today.toISOString().split("T")[0]

    SetVoucherCode("0000000000000") // Set Code
    SetVoucherDate(date)
    SetFromLocation("")
    SetLocationDescFrom("")
    SetToLocation("")
    SetLocationDescTo("")
    SetRemarks1("")
    SetRemarks2("")
    SetRefNo("")
    SetRefCode("")
    SetRefCodeEnable(false)
    SetmainSearchEnable(false)
    SetblDiasableGrid(false)
    setShowTaxTable(false)
    SetVoucherCodeEnable(false)
    setDisable(false)
    SetVoucherDateEnable(false)
    SetFromLocationEnable(false)

    SetRemarks1Enable(false)
    SetRemarks2Enable(false)
    SetRefNoEnable(false)
    setSaveEnable(true)
    setCrEnable(false)
    SetLocationFromDisable(false)
    SetLocationToDisable(false)
    getLocation(LocationCode, 1)
    setDetailRows([{
      code: "",
      desc: "",
      VoucherFrom: "",
      VoucherTo: "",
      DiscPer: 0,
      DiscAmt: 0,
      Amount: 0,
      Selling: 0,
      Cost: 0,
      id: 1,
      disable: false,
      count: 0,
      disableFrom: false,
      disableTo: true,
    }])
    setPaymentList([{
      id: 1,
      Paycode: "",
      PayCodeDisable: false,
      Paydesc: "",
      PayDetcode: "",
      PayDetcodeDesable: true,
      PayDetName: "",
      PayAmount: 0,
      PayAmountDisable: true,
      AccountCode: "",
      AccountCodeDisable: true,
      ExpDate: "",
      ExpDateDisable: true,
      PayDetFormat: ""
    }])
    setCustomerCode("")
    setCustomerName("")
    setSalesAssist("")
    setSalesAssistName("")
    setPriceMode("")
    setDisableSalesAssist(false)
    setDisableCustomer(false)
    setPaidAmount(0)
    setGrossAmount(0)
    setNetAmount(0)
    setDiscountPercentage(0)
    setPrintEnable(false)

  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //default sorted method
  const defaultSortedMain = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  //**Permission Check */
  const permission = (operation) => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    const permissiondata = {
      "strUsername": permissionName,
      "strPassword": permissionPassword,
      "strLocation": LocationCode,
      "strMenuCode": menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {

            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")
                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          })

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }

  // Set values to variables(Data Recall main method)
  const GetVoucherSaleDetails = async code => {

    if (code == "") return;

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")
    const { success, data } = await getVoucherSale(code, LocationCode)
    SetLoadingAlert(false)

    if (!success) {
      displayAlertMessage('danger', "Invalid Voucher Code")
      return
    }

    setCrEnable(true)
    setSaveEnable(false)
    SetFromLocation(data.locationCode)
    getLocation(data.locationCode, 1)
    SetLocationFromDisable(true)
    SetLocationToDisable(true)
    setSalesAssist(data.salesmanCode)
    setSalesAssistName(data.salesmanName)
    setCustomerCode(data.customerCode)
    setCustomerName(data.customerName)
    setPriceMode(data.priceMode)
    setCrBy(data.createdBy)
    setCrDate(data.createdDate)
    setMdBy(data.modifiedBy)
    setMdDate(data.modifiedDate)
    SetVoucherDate(data.voucherDate.slice(0, 10))

    var voucherDetailsList = []
    data.voucherDetails.map(dr => {
      voucherDetailsList.push({
        code: dr.code,
        desc: dr.desc,
        VoucherFrom: dr.voucherFrom,
        VoucherTo: dr.voucherTo,
        DiscPer: dr.discPer,
        DiscAmt: dr.discAmt,
        Amount: parseFloat(dr.amount).toFixed(2),
        Selling: dr.selling,
        Cost: dr.cost,
        id: dr.id,
        disable: true,
        count: dr.count,
        disableFrom: true,
        disableTo: true,
      })
    })

    var voucherPaysList = []

    var totalPaidAmount = 0

    data.voucherPays.map(dr => {
      voucherPaysList.push({
        id: dr.id,
        Paycode: dr.paycode,
        PayCodeDisable: true,
        Paydesc: dr.paydesc,
        PayDetcode: dr.payDetcode,
        PayDetcodeDesable: true,
        PayDetName: dr.payDetName,
        PayAmount: dr.payAmount,
        PayAmountDisable: true,
        AccountCode: dr.accountCode,
        AccountCodeDisable: true,
        ExpDate: dr.expDate,
        ExpDateDisable: true,
        PayDetFormat: ""
      })
      totalPaidAmount = totalPaidAmount + parseFloat(dr.payAmount)
    })

    setDetailRows(voucherDetailsList)
    setPaymentList(voucherPaysList)
    updateCalculatedRows(voucherDetailsList)
    setPaidAmount(totalPaidAmount)
    setDisable(true)
    SetVoucherCodeEnable(true)
    setDisableSalesAssist(true)
    SetVoucherDateEnable(true)
    setDisableCustomer(true)
    SetmainSearchEnable(true)
    SetblDiasableGrid(true)
    SetFromLocationEnable(true)
    SetRemarks1Enable(false)
    SetRemarks2Enable(false)
    SetRefNoEnable(true)
    setPrintEnable(true)


  }

  function getLocation(locCode, search) {
    if (locCode == "" || locCode == undefined) {

      if (search === 1) {
        SetFromLocation("")
        SetLocationDescFrom("")
      } else {
        SetToLocation("")
        SetLocationDescTo("")
      }
      return

    }
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };
    fetch(`${ApiURL}Locations/SearchCode/${locCode}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        const dt = result.data[0];
        if (result.success == true) {
          if (search === 1) {
            SetFromLocation(dt.code)
            SetLocationDescFrom(dt.name)
            SetLocationFromDisable(true)
          } else {
            SetToLocation(dt.code)
            SetLocationDescTo(dt.name)
            SetLocationToDisable(true)
          }
        }
        else {
          if (search === 1) {
            SetFromLocation("")
            SetLocationDescFrom("")
          } else {
            SetToLocation("")
            SetLocationDescTo("")
          }
          displayAlertMessage('danger', "Invalid Location Code")
          return
        }
      })
      .catch(error => console.log('error', error));
  }

  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }

  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);

  }


  async function handlePrint(option) {
    var option = option
    const authToken = localStorage.getItem("authToken")

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")


    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/VoucherSale/report/${LogUserType}/${strVoucherCode}/${LocationCode}/${option == "PDF" ? 1 : 0}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (option == "PDF") {

            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)

          }
          if (option == "XCEL") {

            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)

          }

        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
      })
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb
            title={parentName}
            breadcrumbItem={menuName}
          ></Breadcrumb>
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {
                // alert(permissionReasonShow)
                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                window.location.href = "/";
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 6) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionName("")
                  setPermissionNameDisable(false)
                  setPermissionAlertShow(true)
                }
              }

            }}
            onCancel={() => {
              setsweetAlertShow(false)
              clearPermissionInputs()
            }}
            SupplierOpen={SupplierOpen}
            SetSupplieropen={() => {
              SetSupplieropen(!SupplierOpen)
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, true, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={strReason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              } else if (AlertConfirmOption == 7) {
                permission("Delete")
              } else if (AlertConfirmOption == 6) {
                permission("Print")
                // setprintoptionShow(true)
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}

          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={false}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={printEnable}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to print ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={false}
                    deleteClick={() => {
                      alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <Row>
                    <VoucherTransferInContent
                      Gen_DataSearch={async () => {
                        tog_xlargeMain()
                      }}
                      DataTablesMain={DataTablesMain}
                      Hed_CodeSearchOpenMain={modal_xlargeMain}
                      Hed_CodeSearchTriggerMain={tog_xlargeMain}
                      SearchDataTablesMain={DataTablesMain}

                      SearchDefaultSortedMain={defaultSortedMain}
                      SearchModelOpenMain={modal_xlargeMain}
                      SearchModelTriggerMain={tog_xlargeMain}
                      SearchGetSelectRowMain={GetSelectRowMain}
                      SearchGetSelectRow={GetSelectRow}
                      DataTables={DataTables}
                      Hed_CodeSearchOpen={modal_xlarge}
                      Hed_CodeSearchTrigger={tog_xlarge}
                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      show={AlertShow}
                      Gen_Code={strVoucherCode}
                      Gen_Code_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          13,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetVoucherCode(valCode)
                      }}
                      Gen_Code_onBlur={e => {
                        GetVoucherSaleDetails(e.target.value)
                      }}
                      Gen_Code_Enabled={blVoucherCodeEnable}

                      Gen_FromLocation={strFromLocation}

                      Gen_FromLocation_Enabled={blFromLocationEnable}
                      Gen_ToLocation={strToLocation}

                      Gen_ToLocation_Enabled={blFromLocationEnable}
                      Gen_TxnDate={strVoucherDate}
                      Gen_TxnDate_OnChange={e => {
                        SetVoucherDate(e.target.value)
                      }}
                      Gen_TxnDate_Enabled={blVoucherDateEnable}
                      Gen_Remark1={strRemarks1}
                      Gen_Remark1_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRemarks1(valCode)
                      }}


                      Gen_Remark1_Enabled={blRemarks1Enable}
                      Gen_Remark2={strRemarks2}
                      Gen_Remark2_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRemarks2(valCode)
                      }}
                      Gen_Remark2_Enabled={blRemarks2Enable}
                      SearchDataTables={DataTables}

                      SearchDefaultSorted={defaultSorted}
                      SearchModelOpen={modal_xlarge}
                      SearchModelTrigger={tog_xlarge}
                      Gen_mainSearchEnabled={blmainSearchEnable}
                      Gen_RefCode={strRefCode}
                      Gen_RefCode_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRefCode(valCode)
                      }}
                      Gen_RefCode_Enabled={blRefCodeEnable}
                      Gen_RefCode_onBlur={e => {
                        GetVoucherSaleDetails(e.target.value)
                      }}
                      Gen_VoucherTOSearch={async () => {
                        tog_xlarge()
                      }}
                      Gen_VoucherTOSearchEnabled={blRefCodeEnable}
                      menuCode={menuCode}
                      LocationCode={LocationCode}
                      locationDescTo={locationDescTo}
                      locationDescFrom={locationDescFrom}
                      locationOnblurTo={e => {
                        getLocation(e.target.value, 2)
                      }}
                      locationOnblurFrom={e => {
                        getLocation(e.target.value, 1)
                      }}
                      tox_xlarge_locTo={tox_xlarge_locTo}
                      tox_xlarge_locFrom={tox_xlarge_locFrom}
                      model_xlarge_locFrom={model_xlarge_locFrom}
                      model_xlarge_locTo={model_xlarge_locTo}
                      Gen_FromLocation_OnChange={e => {
                        let val1 = Text(
                          e.target,
                          5,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetFromLocation(val1)
                      }}
                      Gen_ToLocation_OnChange={e => {

                        let val1 = Text(
                          e.target,
                          10,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetToLocation(val1)
                      }}
                      GetSelectRowlOCTo={GetSelectRowLocTo}
                      GetSelectRowLocFrom={GetSelectRowLocFrom}
                      locationFromDisable={locationFromDisable}
                      locationToDisable={locationToDisable}
                      setAlertShow={setAlertShow}
                      setAlertMsg={setAlertMsg}
                      setAlertColor={setAlertColor}
                      menuName={menuName}
                      setSalesAssistName={setSalesAssistName}
                      setSalesAssist={setSalesAssist}
                      setCustomerName={setCustomerName}
                      setCustomerCode={setCustomerCode}
                      salesAssistName={salesAssistName}
                      salesAssist={salesAssist}
                      customerName={customerName}
                      customerCode={customerCode}
                      setPriceMode={setPriceMode}
                      priceMode={priceMode}
                      disableSalesAssist={disableSalesAssist}
                      disableCustomer={disableCustomer}
                      setDisableSalesAssist={setDisableSalesAssist}
                      setDisableCustomer={setDisableCustomer}

                    />
                  </Row>
                  <Row>
                    <VoucherTransferInDetails
                      DataRow={detailRows}
                      setDetailRows={setDetailRows}
                      Disabled={disabled}
                      rowsTax={rowsTax}
                      ShowTaxTable={ShowTaxTable}
                      blDiasableGrid={blDiasableGrid}
                      strFromLocation={strFromLocation}
                      menuCode={menuCode}
                      LocationCode={LocationCode}
                      menuName={menuName}
                      updateCalculatedRows={updateCalculatedRows}
                      SetLoadingAlert={SetLoadingAlert}
                      SetLoadingAlerttitle={SetLoadingAlerttitle}
                    />
                  </Row>
                  <Row>
                    <VoucherSellSummarySection
                      grossAmount={grossAmount}
                      setGrossAmount={setGrossAmount}
                      discountPercentage={discountPercentage}
                      setDiscountPercentage={setDiscountPercentage}
                      discountAmount={discountAmount}
                      updateCalculatedRows={updateCalculatedRows}
                      netAmount={netAmount}
                      disable={disable}
                    />
                  </Row>
                  <Row>
                    <VoucherPayments
                      setPaymentList={setPaymentList}
                      paymentList={paymentList}
                      disable={disable}
                      menuCode={menuCode}
                      CalculatePaidAmount={CalculatePaidAmount}
                      paidAmount={paidAmount}
                      netAmount={netAmount}
                      menuName={menuName}
                    />
                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VoucherSell